export const environment = {
  production: false,

  apiRoot: "https://afg-api.codingwestmoreland.com/", // Base URL for the api
  stsAuthority: "https://afg-api.codingwestmoreland.com/", // Base URL for the token service
  clientId: "AFG_SecureAccount", // Client ID of this application on the token server
  clientRoot: "https://afg.codingwestmoreland.com/", // Base URL of the client application
  clientSecret: "9fd1f894-a636-4305-a1e5-fbc684624f7e",
  logErrorsToAPI: false,
  requireExportPassword: true,
  version: "1.0.0.2",
  idle: 1770, // 29.5 minutes
};
